import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "../../AxiosClient";
import { Pie } from "react-chartjs-2";

export class DocumentInfoChart extends Component {
  static propTypes = {
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    documentID: PropTypes.number.isRequired,
  };

  state = {
    data: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.document !== this.props.document) {
      this.mapDataFormat();
    }
  }

  componentDidMount() {
    this.mapDataFormat();
  }

  mapDataFormat = () => {
    this.setState({
      data: {
        labels: ["Liked", "Favourited", "Viewed", "Used"],
        datasets: [
          {
            data: [
              this.props.document.likedCount,
              this.props.document.favouritedCount,
              this.props.document.viewedCount,
              this.props.document.usedCount,
            ],
          },
        ],
      },
    });
  };

  render() {
    return (
      <div
        style={{
          position: "relative",
          marginBottom: 20,
        }}
      >
        <Pie
          data={this.state.data}
          options={{
            responsive: true,
            legend: { display: false },
            maintainAspectRatio: false,
          }}
        />
      </div>
    );
  }

  getData = () => {
    axios.get(`/document/${this.props.documentID}/stats`, { withCredentials:true }).then((res) => {
      this.setState({ data: res.data.data });
    });
  };
}

const mapStateToProps = (state) => ({
  filters: state.search.filters,
  message: state.websocket.message,
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(DocumentInfoChart));
